/* SUR+ 3D layer: chrome floor under the hero and the runway, floating garments in every product grid, garments that fly into the bag */
(function(){
var w=window,d=document;
if(w.SPFly)return;
var reduce=!!(w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches);
function clamp(v,a,b){return v<a?a:(v>b?b:v)}

/* ---------- the floor: a perspective grid that rolls toward you. Drawn on a canvas, so it looks and moves
   the same in every browser and on every phone, with boxes sized to the screen. ---------- */
var FLOORS={
 hero:{ink:'196,200,204',a:0.3,fade:0.42,tail:0,period:2.4,cell:function(W){return W<750?W/4.4:clamp(W/6.5,130,300)},zn:function(W){return W<750?2.4:1.35}},
 runway:{ink:'10,10,10',a:0.1,fade:0.3,tail:0.64,period:2.8,cell:function(W){return W<750?W/4:clamp(W/9,100,220)},zn:function(W){return W<750?2.2:1.6}}
};
var fl=[],fraf=0,ft=0,fio=null,fro=null;
function fDraw(f){
 var W=f.W,H=f.H,o=f.o,cx=f.cx;if(!W||!H)return;
 cx.setTransform(f.r,0,0,f.r,0,0);cx.clearRect(0,0,W,H);
 var cell=o.cell(W),zn=o.zn(W),mid=W/2,col='rgba('+o.ink+',',g=cx.createLinearGradient(0,0,0,H);
 g.addColorStop(0,col+'0)');g.addColorStop(o.fade,col+o.a+')');
 if(o.tail){g.addColorStop(o.tail,col+o.a+')');g.addColorStop(1,col+'0)')}else g.addColorStop(1,col+o.a+')');
 cx.strokeStyle=g;cx.lineWidth=1;cx.beginPath();
 /* lines along the floor, meeting at the horizon */
 for(var m=Math.min(60,Math.ceil(mid/cell*7)),i=-m;i<=m;i++){cx.moveTo(mid,0);cx.lineTo(mid+i*cell,H)}
 /* lines across it: row j is j+1-phase boxes away, so the rows walk toward you and loop without a seam */
 for(var j=0;j<90;j++){var y=H*zn/(zn+j+1-f.ph);if(y<0.6)break;if(y>H)continue;cx.moveTo(0,y);cx.lineTo(W,y)}
 cx.stroke();
}
function fLoop(t){fraf=0;var dt=ft?Math.min((t-ft)/1000,0.1):0,any=false;ft=t;
 for(var i=0;i<fl.length;i++){var f=fl[i];if(!f.seen||!f.box.isConnected)continue;any=true;f.ph=(f.ph+dt/f.o.period)%1;fDraw(f)}
 if(any&&!d.hidden)fraf=requestAnimationFrame(fLoop);else ft=0}
function fKick(){if(!reduce&&!fraf&&!d.hidden)fraf=requestAnimationFrame(fLoop)}
function fSize(f){var r=Math.min(w.devicePixelRatio||1,2),W=f.box.offsetWidth,H=f.box.offsetHeight;if(W*r>4096)r=4096/W;if(W===f.W&&H===f.H&&r===f.r)return;f.W=W;f.H=H;f.r=r;f.cv.width=Math.round(W*r);f.cv.height=Math.round(H*r);fDraw(f)}
/* box: the element the floor fills; kind: 'hero' (chrome on black) or 'runway' (graphite on white). False when canvas is unavailable. */
function SPFloor(box,kind){
 var cv=d.createElement('canvas'),cx=null;
 try{cx=cv.getContext('2d')}catch(e){}
 if(!cx)return false;
 cv.className='sp-floor__cv';box.classList.add('is-cv');box.appendChild(cv);
 var f={box:box,cv:cv,cx:cx,o:FLOORS[kind]||FLOORS.hero,W:0,H:0,r:1,ph:0,seen:true};fl.push(f);
 if(!fio&&'IntersectionObserver' in w)fio=new IntersectionObserver(function(es){es.forEach(function(e){fl.forEach(function(x){if(x.box===e.target)x.seen=e.isIntersecting})});fKick()},{rootMargin:'80px'});
 if(fio){f.seen=false;fio.observe(box)}
 if(!fro&&w.ResizeObserver)fro=new ResizeObserver(function(es){es.forEach(function(e){fl.forEach(function(x){if(x.box===e.target)fSize(x)})})});
 if(fro)fro.observe(box);
 fSize(f);fKick();
 return true;
}
d.addEventListener('visibilitychange',fKick);
w.SPFloor=SPFloor;
function floor(){
 d.querySelectorAll('.sp-hero').forEach(function(h){
  if(h.querySelector(':scope > .sp-floor'))return;
  var f=d.createElement('div');f.className='sp-floor';f.setAttribute('aria-hidden','true');
  h.insertBefore(f,h.firstChild);
  if(!SPFloor(f,'hero'))f.appendChild(d.createElement('i'));
 });
}
/* product cards: lift each garment off its photo so it floats in a little studio */
function grid(){
 if(!w.SPCut)return;
 d.querySelectorAll('main .card-gallery').forEach(function(g){
  if(g.dataset.spG)return;g.dataset.spG='1';g.classList.add('sp-g');
  g.querySelectorAll('img').forEach(function(im){w.SPCut.lift(im)});
 });
}

/* ---------- into the bag ---------- */
function bagEl(){return d.querySelector('cart-icon')||d.querySelector('.header-actions__cart-icon')||d.querySelector('#header-component a[href$="/cart"]')}
function visible(r){return r&&r.width>0&&r.bottom>0&&r.top<w.innerHeight}
function bounce(el){if(el&&el.animate&&!reduce)el.animate([{transform:'scale(1)'},{transform:'scale(1.35) rotate(-10deg)'},{transform:'scale(.9) rotate(6deg)'},{transform:'scale(1)'}],{duration:650,easing:'cubic-bezier(.16,1,.3,1)'})}
/* src: an <img> (or its url) and the rectangle it starts from */
function fly(src,rect){
 var bag=bagEl(),q=bag&&bag.getBoundingClientRect(),url=typeof src==='string'?src:(src&&(src.currentSrc||src.src));
 if(!url||!visible(q)){bounce(bag);return}
 rect=rect||(src.getBoundingClientRect&&src.getBoundingClientRect());
 if(reduce||!rect||!rect.width){bounce(bag);return}
 var s=Math.min(1,260/Math.max(rect.width,rect.height)),wd=rect.width*s,ht=rect.height*s;
 var x0=rect.left+(rect.width-wd)/2,y0=rect.top+(rect.height-ht)/2;
 var im=new Image();im.src=url;im.alt='';im.className='sp-fly';im.setAttribute('aria-hidden','true');
 im.style.width=wd+'px';im.style.height=ht+'px';im.style.left=x0+'px';im.style.top=y0+'px';
 d.body.appendChild(im);
 var dx=q.left+q.width/2-(x0+wd/2),dy=q.top+q.height/2-(y0+ht/2);
 var a=im.animate([
  {transform:'perspective(900px) translate3d(0,0,0) rotateY(0deg) scale(1)',opacity:1},
  {transform:'perspective(900px) translate3d('+(dx*0.3).toFixed(1)+'px,'+(dy*0.3-150).toFixed(1)+'px,140px) rotateY(200deg) rotateZ(-10deg) scale(.72)',opacity:1,offset:0.45},
  {transform:'perspective(900px) translate3d('+dx.toFixed(1)+'px,'+dy.toFixed(1)+'px,0) rotateY(420deg) rotateZ(0deg) scale(.08)',opacity:.5}
 ],{duration:950,easing:'cubic-bezier(.45,0,.25,1)'});
 a.onfinish=a.oncancel=function(){im.remove();bounce(bag)};
}
var toastEl=null,toastT=null;
function toast(msg){
 if(!toastEl){toastEl=d.createElement('div');toastEl.className='sp-toast';toastEl.setAttribute('role','status');d.body.appendChild(toastEl)}
 toastEl.textContent=msg;toastEl.classList.add('in');clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('in')},2400);
}
/* keep the bag count right after an add that did not go through the theme's own cart events */
var quietUntil=0;
function refreshBag(){
 return fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){
  var ci=d.querySelector('cart-icon');quietUntil=Date.now()+1500;
  if(ci&&typeof ci.renderCartBubble==='function')ci.renderCartBubble(c.item_count);
  return c;
 }).catch(function(){});
}
/* any other add button: remember which garment was added, fly it when the bag count goes up */
var armed=null,lastCount=null;
function countNow(){var n=d.querySelector('cart-icon [ref="cartBubbleCount"]');return n?parseInt(n.textContent||'0',10)||0:null}
function sourceFor(btn){var n=btn;for(var i=0;n&&i<10;i++,n=n.parentElement){var im=n.querySelector&&n.querySelector('.sp-pv__img,.card-gallery img,.sp-card__img img,.sp-look__face');if(im)return im}return null}
d.addEventListener('click',function(e){
 var b=e.target&&e.target.closest&&e.target.closest('.add-to-cart-button,button[name="add"],.quick-add__button,.sp-add');
 if(b)armed={src:sourceFor(b),t:Date.now()};
},true);
function watchBag(){
 var ci=d.querySelector('cart-icon');if(!ci||ci.dataset.spWatch||!('MutationObserver' in w))return;ci.dataset.spWatch='1';lastCount=countNow();
 new MutationObserver(function(){var n=countNow();if(n==null)return;var up=lastCount!=null&&n>lastCount;lastCount=n;
  if(!up||Date.now()<quietUntil)return;
  if(armed&&Date.now()-armed.t<8000){var a=armed;armed=null;if(a.src)fly(a.src);else bounce(bagEl())}else bounce(bagEl());
 }).observe(ci,{subtree:true,childList:true,characterData:true});
}
w.SPFly={fly:fly,toast:toast,refreshBag:refreshBag};

/* ---------- delivery estimate: free delivery, up to ETA_DAYS working days (Mon to Sat, Pakistan time),
   counted from the next working day because there is no same-day cut-off. Change ETA_DAYS if delivery times change. ---------- */
var ETA_DAYS=7;
var TRUCK='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3.5 3.5v2.5h-7.5"/><circle cx="7" cy="17" r="1.8"/><circle cx="17.5" cy="17" r="1.8"/></svg>';
function etaDate(){
 var p={};
 try{new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Karachi',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date()).forEach(function(x){p[x.type]=x.value})}
 catch(e){var n=new Date();p={year:n.getFullYear(),month:n.getMonth()+1,day:n.getDate()}}
 var t=new Date(Date.UTC(+p.year,+p.month-1,+p.day,12)),k=0;
 while(k<ETA_DAYS){t.setUTCDate(t.getUTCDate()+1);if(t.getUTCDay()!==0)k++}
 return t.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'UTC'}).replace(',','');
}
function etaFill(node){node.innerHTML=TRUCK+'<span><b>Free delivery</b> · Order today, arrives by <b>'+etaDate()+'</b></span>';return node}
w.SPEta={date:etaDate,fill:etaFill};

function init(){floor();grid();watchBag()}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
d.addEventListener('shopify:section:load',init);
/* filters, sorting and "load more" redraw the grid */
if('MutationObserver' in w)d.addEventListener('DOMContentLoaded',function(){var m=d.querySelector('main');if(!m)return;var t=null;new MutationObserver(function(){clearTimeout(t);t=setTimeout(grid,180)}).observe(m,{childList:true,subtree:true})});
})();
